import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-visor-comentarios-anulacion',
  templateUrl: './visor-comentarios-anulacion.component.html',
  styleUrls: ['./visor-comentarios-anulacion.component.scss']
})
export class VisorComentariosAnulacionComponent {

  @Input() comentario: string;
  
  constructor(public activeModal: NgbActiveModal) { }

}
